import { render } from "./pbsyllf.vue?vue&type=template&id=2f35b95a&scoped=true&ts=true"
import script from "./pbsyllf.vue?vue&type=script&lang=ts"
export * from "./pbsyllf.vue?vue&type=script&lang=ts"

import "./pbsyllf.vue?vue&type=style&index=0&id=2f35b95a&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f35b95a"]])

export default __exports__